import React from "react";
import { Header } from '../../../Components/Layout/Header.jsx';
import { ObavijestiCasino } from '../../../Components/Layout/ObavijestiCasino.jsx';
import { MetaTags } from '../../../Components/Layout/MetaTags.jsx';

export default function Tvrtki(props) {
    return (
        <div>
            <MetaTags title="VIP Igrači | Postani dio Ekskluzivnog Casino Kluba | SuperCasino" description="VIP SuperSport Casino!" />
            <Header key="header" {...props} />

            <div className="o-tvrtki">
                <div className="title">
                    <h1>O tvrtki</h1>
                    <p>
                        SuperSport i „Sportsko klađenje“ odavno su sinonimi u hrvatskom kladioničarskom svijetu, pa nije čudno da je istim putem krenuo i SuperCasino koji polako, ali sigurno diktira trendove u casino industriji. SuperCasino ima jasno definirane standarde poštene poslovne prakse, pri čemu je naglasak stavljen na osiguranju zabavne i pouzdane igre, te pružanju podrške svim svojim igračima u maksimalno sigurnom okruženju.
                    </p>
                </div>
                <div className="info">
                    <div className="logo-container">
                        <img src="./Content/Images/OTvrtki/SuperSportLogo.png" alt="SuperSport Logo" />
                        <img src="./Content/Images/OTvrtki/SuperCasinoLogo.png" alt="SuperCasino Logo" />
                    </div>
                    <div className="info-container">
                        <h2>Naziv</h2>
                        <p>Super Sport kladionica, društvo s ograničenom odgovornošću</p>
                        <hr />
                        <h2>Skraćeni naziv</h2>
                        <p className="red">Super Sport d.o.o.</p>
                        <hr />
                        <h2>Sjedište</h2>
                        <p>Zagreb, Krčka 18/d</p>
                        <hr />
                        <h2>Sud kod kojega je tvrtka upisana u sudski
                            registar
                        </h2>
                        <p>Trgovački sud u Zagrebu</p>
                        <hr />
                        <h2>Broj pod kojim je tvrtka upisana u sudski
                            registar
                        </h2>
                        <p>080352592</p>
                        <hr />
                        <h2>OIB</h2>
                        <p className="red">48471634697</p>
                        <hr />
                        <h2>Iznos kapitala</h2>
                        <p>308.000.000,00 kuna / 40.878.624,99 euro<br />
                            (fiksni tečaj konverzije 7,53450)<br />
                            uplaćen u cijelosti
                        </p>
                        <hr />
                        <h2>Direktori</h2>
                        <p>Goran Đurić</p>
                        <p>Branislav Trifković</p>
                        <p>Radim Haluza</p>
                        <hr />
                        <h2>Račun</h2>
                        <p className="red">Raiffeisenbank Austria d.d.<br />
                            Zagreb Petrinjska 59<br />
                            Broj računa: HR5224840081100849406
                        </p>
                        <hr />
                        <h2>Urudžbeni broj i klasa odobrenja za priređivanje
                            internet klađenja
                        </h2>
                        <p>
                            Klasa: UP/I-461-05/10-01/667<br />
                            Urudžbeni broj: 513-07-21-07/10-2<br />
                            Zagreb, 22. srpnja 2010.
                        </p>
                        <hr />
                        <h2>
                            Urudžbeni broj i klasa odobrenja za priređivanje igara
                            na sreću u casinima putem interaktivnih prodajnih
                            kanala on-line igre
                        </h2>
                        <p>
                            Klasa: UP/I-461-01/15-01/140<br />
                            Urudžbeni broj: 513-07-21-01/16-7<br />
                            Zagreb, 30. prosinca 2016.
                        </p>
                    </div>
                </div>
            </div>
            <ObavijestiCasino {...props}></ObavijestiCasino>
        </div>
    )
};